import React, { useCallback } from 'react';

import { isEmpty } from 'lodash';

import { Card, Container, MarginBottom } from './Styled';

import Text from 'components/Text';
import Button from 'components/Button';
import CardDisplay from 'components/common/Card';

import TextInput from 'components/TextInput';
import { context as valuesContext } from 'components/ValuesProvider';
import { ErrorMessage } from 'components/ErrorMessage';
import { ACCOUNT_DETAILS } from 'constants/errors';

import { userValidator } from './validation';

const UserDetails = ({ error, isLoadingDetails, updateUser }) => {
  const saveHandler = useCallback((context) => {
    let values = context.getValues();
    let errors = userValidator(values);

    isEmpty(errors) ? updateUser(values) : context.setErrors(errors);
  });

  return (
    <Container>
      <Card height="100%">
        <MarginBottom>
          <CardDisplay.SubTitle>User</CardDisplay.SubTitle>
          <Text.Info>Manage and update your details</Text.Info>
        </MarginBottom>
        <TextInput
          bold
          name="first_name"
          label={'First Name'}
          context={valuesContext}
          disabled={isLoadingDetails}
          placeholder={`Enter your first name`}
        />
        <TextInput
          bold
          name="last_name"
          label={'Last Name'}
          context={valuesContext}
          disabled={isLoadingDetails}
          placeholder={`Enter your last name`}
        />
        <TextInput
          bold
          name="mobile_number"
          label={'Mobile number'}
          context={valuesContext}
          disabled={isLoadingDetails}
          placeholder={`Enter your mobile number`}
        />

        <Button.Default
          inline
          label="Save"
          onClick={saveHandler}
          context={valuesContext}
          loading={isLoadingDetails}
          disabled={isLoadingDetails}
        />

        <ErrorMessage error={error} for={ACCOUNT_DETAILS} />
      </Card>
    </Container>
  );
};

export default UserDetails;
